import { z } from 'zod'
import { apiRequest } from '@/lib/api-client'

export const briefingTimeOfDaySchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/)

export const briefingSubscriptionInputSchema = z
  .object({
    enabled: z.boolean(),
    time_of_day: briefingTimeOfDaySchema,
    email_enabled: z.boolean(),
  })
  .strict()
export type BriefingSubscriptionInput = z.infer<typeof briefingSubscriptionInputSchema>

const briefingSubscriptionSchema = z.object({
  enabled: z.boolean(),
  time_of_day: z.string(),
  email_enabled: z.boolean(),
  timezone: z.string(),
  last_run_on: z.string().nullable(),
  last_status: z.string().nullable(),
  last_path: z.string().nullable(),
})

const briefingSubscriptionResponseSchema = z.object({
  subscription: briefingSubscriptionSchema,
  role: z.enum(['owner', 'admin', 'member', 'viewer']),
  email_available: z.boolean(),
})

export type BriefingSubscriptionResponse = z.infer<typeof briefingSubscriptionResponseSchema>

export function fetchBriefingSubscription(): Promise<BriefingSubscriptionResponse> {
  return apiRequest({ path: '/briefing/subscription', schema: briefingSubscriptionResponseSchema })
}

export function saveBriefingSubscription(
  input: BriefingSubscriptionInput,
): Promise<BriefingSubscriptionResponse> {
  return apiRequest({
    method: 'PUT',
    path: '/briefing/subscription',
    body: input,
    schema: briefingSubscriptionResponseSchema,
  })
}
